import _classCallCheck from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var getRatio = function getRatio() {
  var ratio;

  ratio = function () {
    var ctx = window.document.createElement('canvas').getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    return dpr / bsr;
  }();

  ratio = Math.max(ratio, 2);
  return ratio;
};

export var BaseCanvas = /*#__PURE__*/function () {
  function BaseCanvas(id, options) {
    var _this = this;

    _classCallCheck(this, BaseCanvas);

    this.ratio = 1;
    this.timer = 0;
    this.x = -1;
    this.y = -1;
    this.renderedTimer = {};

    this.limitMaxFPS = function (limit, fn) {
      var limitRenderGap = 1000 / limit;
      var lastRenderAt = _this.renderedTimer[fn];

      if (!lastRenderAt || _this.timer - lastRenderAt > limitRenderGap) {
        fn.call(_this);
        _this.renderedTimer[fn] = _this.timer;
      }
    };

    this.draw = function (timer) {
      _this.timer = timer;

      if (!_this.running) {
        return;
      }

      _this.adjustWidth();

      _this.adjustHeight();

      _this.drawFrame(timer);

      var showFPS = _this.options.showFPS;

      if (showFPS) {
        if (_this.timer) {
          var fps = Math.floor(1000 / (timer - _this.timer));

          _this.drawFPS(fps);
        }
      }

      _this.timer = timer;

      if (_this.options.afterDraw) {
        _this.options.afterDraw();
      }

      requestAnimationFrame(_this.draw);
    };

    this.ratio = getRatio();
    this.running = false;
    this.options = options;
    this.canvas = document.getElementById(id);
    this.ctx = this.canvas.getContext('2d');
    this.setupCanvas();
    this.bindBaseMouseEvent();
  }

  _createClass(BaseCanvas, [{
    key: "adjustWidth",
    value: function adjustWidth() {
      var w = this.canvas.parentElement.clientWidth;
      this.setWidth(w * this.ratio);
    }
  }, {
    key: "adjustHeight",
    value: function adjustHeight() {
      if (this.options.height === -1) {
        this.setHeight(this.canvas.parentElement.clientHeight * this.ratio);
      } else {
        this.setHeight(this.options.height * this.ratio);
      }
    }
  }, {
    key: "onResizeWidth",
    value: function onResizeWidth() {}
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      if (this.canvas.width !== width) {
        this.canvas.width = width;

        if (this.onResizeWidth) {
          this.onResizeWidth();
        }
      }
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      if (this.canvas.height !== height) {
        this.canvas.height = height;
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      this.options = Object.assign({}, this.options, options);

      if (this.installOptions) {
        this.installOptions();
      }
    }
  }, {
    key: "setupCanvas",
    value: function setupCanvas() {
      this.canvas.style.width = '100%';

      if (this.options.height === -1) {
        this.canvas.style.height = '100%';
      } else {
        this.canvas.style.height = "".concat(this.options.height, "px");
      }

      this.ctx.setTransform(this.ratio, 0, 0, this.ratio, 0, 0);
    }
  }, {
    key: "start",
    value: function start() {
      this.running = true;
      requestAnimationFrame(this.draw);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.running = false;
    }
  }, {
    key: "installOptions",
    value: function installOptions() {}
  }, {
    key: "drawFPS",
    value: function drawFPS(fps) {
      this.ctx.textAlign = 'right';
      this.ctx.fillStyle = '#FFFFFF';
      this.ctx.fillText("FPS: ".concat(fps), this.canvas.width / 2, this.canvas.height / 2);
    }
  }, {
    key: "drawFrame",
    value: function drawFrame(timer) {
      throw new Error('draw frame not implement');
    }
  }, {
    key: "bindBaseMouseEvent",
    value: function bindBaseMouseEvent() {
      var _this2 = this;

      this.canvas.onmouseleave = function (e) {
        _this2.x = -1;
        _this2.y = -1;
      };

      this.canvas.onmousemove = function (e) {
        _this2.x = e.offsetX * _this2.ratio;
        _this2.y = e.offsetY * _this2.ratio;
      };
    }
  }]);

  return BaseCanvas;
}();